import React from 'react'
import { Popup } from 'src/components'
import { IAnimal } from 'src/dto/animal.dto'
import { useStyles } from './styles'
import cowIcon from 'src/assets/images/cow_icon.png'

interface LotAnimalsModalProps {
  isOpen: boolean
  onClose: () => void
  animals: IAnimal[]
}

export const LotAnimalsModal: React.FC<LotAnimalsModalProps> = ({ isOpen, onClose, animals }) => {
  const style = useStyles()

  if (!isOpen) return null

  return (
    <Popup title='Animais do Lote' onClose={onClose}>
      <div className={style.modalContent}>
        <p className={style.modalDescription}>Os seguintes animais do lote serão incluídos no processo de cobertura:</p>
        <div className={style.animalList}>
          {animals.map((animal) => (
            <div key={animal.idAnimal} className={style.animalCard}>
              <span className={style.animalNumber}>
                <img src={cowIcon} alt='Cow Icon ' />
              </span>
              <div className={style.animalInfo}>
                <div className={style.animalInfoRow}>
                  <strong className={style.animalName}>{animal.nome || 'Sem nome'}</strong>
                </div>
                <div className={style.animalInfoRow}>
                  <span className={style.animalLabel}>Número:</span>
                  <span className={style.animalValue}>{animal.cdn || '-'}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className={style.modalActions}>
          <button type='button' className={style.closeButton} onClick={onClose}>
            Fechar
          </button>
        </div>
      </div>
    </Popup>
  )
}
